import { render, staticRenderFns } from "./TableConent.vue?vue&type=template&id=3a5c22dd&scoped=true&"
import script from "./TableConent.vue?vue&type=script&lang=js&"
export * from "./TableConent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c22dd",
  null
  
)

export default component.exports